exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nova-ocorrencia {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 2rem;\n}\n", ""]);

// exports
